// import { useState, useEffect } from 'react';

const MFA = () => {

	return (
		<div> This is MFA</div>
	)
}
export default MFA;